<script setup>
import { reactive } from 'vue'
import useRole from '../../../store/role.store'
import { useQuasar } from 'quasar'
import { callApi } from '../../../utils'
import { useI18n } from "vue-i18n"
const { t } = useI18n()

const $q = useQuasar()

const data = reactive({
  name: null
})

const { getRoleList, loading, pagination } = useRole()

function filter () {
  callApi([getRoleList], {
    'page-size': parseInt(pagination.value.rowsPerPage),
    name: data.name
  }, $q, loading, true)
}

function reset () {
  data.name = null
  callApi([getRoleList], { 
    'page-size': parseInt(pagination.value.rowsPerPage) 
  }, $q, loading, true)
}

</script>

<template lang='pug'>
.role-filter
  q-form(
    @submit='filter'
    @reset='reset'
    class="filter"
  )
    .column
      .col-auto.q-mb-md
        q-input(
          outlined
          v-model='data.name'
          :label='t("customer.name")'
          hide-hint
          hide-bottom-space
        )
      .col-auto.q-mb-md
        q-btn(
          style='width: 100%; height: 46px'
          :label="t('actions.clear')"
          :loading='loading'
          type="reset"
          flat
        )
      .col-auto
        q-btn(
          style='width: 100%; height: 46px'
          :label="t('actions.search')"
          :loading='loading'
          type="submit"
          outline
          size='auto'
          color='primary'
        )
</template>